export const defaultPostSubmitAnswers = {
  BuyerAgentQuestion: { has_buyer_agent: "declined" },
  FinancingQuestion: { financing_status: "declined" }
};
